import { RandomTrackResponse } from 'src/app/shared/models/tracks-sfx/random-track-response.model';
import { DownloadResponse } from '../models/download-response.model';
import { Category } from '../models/category.model';
import { TrackResponse } from '../../tracks-sfx/models/track-response';
import { Track } from '../models/tracks-sfx/track.model';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Service } from 'src/app/shared/services/service';
import { SearchParams } from '../models/search-params.model';


@Injectable({
  providedIn: 'root'
})
export class TracksService extends Service {

  constructor(http: HttpClient) {
    super(http);
  }

  getAll(): Observable<TrackResponse> {
    return this.http.get<TrackResponse>(this.url + '/snack/v1/tracks');
  }

  get(id, slug: string, soundEffect = false): Observable<Track> {
    if (soundEffect) {
      return this.http.get<Track>(this.url + '/snack/v1/sfx/' + id, { params: { slug } });
    } else {
      return this.http.get<Track>(this.url + '/snack/v1/tracks/' + id, { params: { slug } });
    }
  }

  getRandom(): Observable<RandomTrackResponse> {
    return this.http.get<RandomTrackResponse>(this.url + '/snack/v1/tracks/maybegiveme10songs');
  }

  search(searchParams: SearchParams, pageSize = 24, searchSoundEffects = false): Observable<TrackResponse> {
    const params = searchParams.getDefined();
    if (params.orderBy === 'title') {
      params.order = 'ASC';
    } else {
      params.order = 'DESC';
    }
    params.pageSize = pageSize;
    if (searchSoundEffects) {
      return this.http.get<TrackResponse>(this.url + '/snack/v1/sfx', { params });
    } else {
      return this.http.get<TrackResponse>(this.url + '/snack/v1/tracks', { params });
    }
  }

  getCategories(): Observable<Category> {
    return this.http.get<Category>(this.url + '/snack/v1/tracks/categories');
  }

  download(trackId: number, isSoundEffect: boolean = false): Observable<DownloadResponse> {
    if (isSoundEffect) {
      return this.http.get<DownloadResponse>(this.url + '/snack/v1/download/sfx/' + trackId);
    }
    return this.http.get<DownloadResponse>(this.url + '/snack/v1/download/track/' + trackId);
  }

}
